import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../../../common/html/element'
import { Icon } from '../../../../../../common/html/icon'
import TextEllipsis from '../../../../../../common/textEllipsis'
import { LOCATION_TYPE } from '../../../../common/constant'
import { changeCriteria, selectCriteria } from '../../../store/slice'
import { selectLocationById } from './../../../../common/store/slice'

export const DropdownItem = ({
  item,
  locationType,
  criteriaGroup,
  screeningIndicatorId,
}) => {
  const dispatch = useDispatch()
  const locationById = useSelector(selectLocationById())

  const selectedData =
    useSelector(
      selectCriteria([criteriaGroup, screeningIndicatorId, 'data']),
    ) || []

  const isSelected = useMemo(() => {
    if (!selectedData || selectedData.length === 0) return false
    switch (locationType) {
      case LOCATION_TYPE.PROVINCE:
        return selectedData.some(
          (province) => province.Province.LocationId === item.id,
        )
      case LOCATION_TYPE.DISTRICT:
        return selectedData.some((province) =>
          province.Province.Districts.some(
            (district) => district.LocationId === item.id,
          ),
        )
      default:
        break
    }
  }, [selectedData, item.id])

  const onToggleItem = () => {
    let newSelectedData = JSON.parse(JSON.stringify(selectedData))

    // Remove from location
    if (isSelected) {
      switch (locationType) {
        case LOCATION_TYPE.PROVINCE:
          newSelectedData = newSelectedData.filter((data) => {
            return data.Province.LocationId !== item.id
          })
          break
        case LOCATION_TYPE.DISTRICT:
          const parentProvinceId = locationById[item.parentId]?.id
          if (parentProvinceId) {
            const provinceIndex = newSelectedData.findIndex(
              (data) => data.Province.LocationId === parentProvinceId,
            )
            if (provinceIndex !== -1) {
              newSelectedData[provinceIndex].Province.Districts =
                newSelectedData[provinceIndex].Province.Districts.filter(
                  (district) => district.LocationId !== item.id,
                )
            }
          }
          break
        default:
          return ''
      }
    }

    // Add to location
    if (!isSelected) {
      dispatch(
        changeCriteria({
          path: [criteriaGroup, screeningIndicatorId, 'error'],
          data: undefined,
        }),
      )

      switch (locationType) {
        case LOCATION_TYPE.PROVINCE:
          newSelectedData.push({
            Province: { LocationId: item.id, Districts: [] },
          })
          break
        case LOCATION_TYPE.DISTRICT:
          const parentProvinceId = locationById[item.parentId]?.id
          if (parentProvinceId) {
            let provinceIndex = newSelectedData.findIndex(
              (item) => item.Province.LocationId === parentProvinceId,
            )
            if (provinceIndex === -1) {
              newSelectedData.push({
                Province: { LocationId: parentProvinceId, Districts: [] },
              })
              provinceIndex = newSelectedData.length - 1
            }
            newSelectedData[provinceIndex].Province.Districts.push({
              LocationId: item.id,
              Wards: [],
            })
          }
          break
        default:
          return
      }
    }

    dispatch(
      changeCriteria({
        path: [criteriaGroup, screeningIndicatorId, 'data'],
        data: newSelectedData,
      }),
    )
  }

  const getDisplayText = () => {
    switch (locationType) {
      case LOCATION_TYPE.PROVINCE:
        return item.name
      case LOCATION_TYPE.DISTRICT:
        const provinceName = locationById[item.parentId]?.name
        return item.name + ` (${provinceName})`
      default:
        return ''
    }
  }

  return (
    <Element
      elementName="li"
      style={{ borderColor: '#D5D5D5' }}
      onClick={() => onToggleItem(item)}
    >
      <Icon
        className={isSelected ? 'icon-checkbox-check' : 'icon-checkbox-uncheck'}
        style={{
          fontSize: 15,
          color: isSelected ? '#2C73E8' : '#9C9C9C',
        }}
      />
      <TextEllipsis text={getDisplayText()} isI18n={false} zIndexTooltip={13} />
    </Element>
  )
}
